import _ from "lodash";
import Api from "./fnapi-client";
import Storage from "./storage";
import * as config from "../config";
import Promise from "es6-promise"
export default {

  // We'll probably want separate functions to hit up application, user, company objects
  updateEntityProperty: function(
    entityType,
    entityId,
    property,
    value,
    callback
  ){

    switch (entityType){
      case 'application':
        this.updateApplicationProperty(entityId, property, value, callback);
        break;
      default:
        if (callback) callback(false);
        break;
    }
  },

  updateApplicationProperty: function(
    entityId,
    property,
    value,
    callback
  ){
    var endpoint = 'application/' + entityId + '/update';
    var payload = {};
    payload[property] = value;

    // Post
    Api.post(endpoint,payload).then( (response) => {
      if (callback) callback(true);
    }).catch( (error) => {
      if (callback) callback(false);
      alert("Error: " + error.message);
    });
  }

}


// WEBPACK FOOTER //
// ./src/js/utilities/entity-handler.jsx